import script from "./infocollectform.vue?vue&type=script&setup=true&lang=js"
export * from "./infocollectform.vue?vue&type=script&setup=true&lang=js"

import "./infocollectform.vue?vue&type=style&index=0&id=1fca28f5&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/71c6cef2-472d-494c-a008-9cabd81db8d4/workspace/web_hou_2FD6/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fca28f5"]])

export default __exports__